import { render, staticRenderFns } from "./studyFile.vue?vue&type=template&id=0789709e&"
import script from "./studyFile.vue?vue&type=script&lang=js&"
export * from "./studyFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports